export default __webpack_public_path__ + "static/media/regulatory--traffic-signal-photo-enforced--g1.f6a31551.png";